import {
    FavoriteData,
    FavoriteCreateForm,
    FavoriteUpdateForm,
    FavoriteResponse,
    FavoriteListResponse,
    FavoriteListQuery,
    FavoriteOrderUpdateParams,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/user';

export class FavoriteApi {
    public static async get(userId: string, favoriteId: string): Promise<FavoriteData> {
        const res = await axios.get<FavoriteResponse>(`${BASE_URL}/${userId}/favorite/${favoriteId}`);

        return res.data.favorite;
    }

    public static async getList(userId: string, params: FavoriteListQuery): Promise<FavoriteData[]> {
        const res = await axios.get<FavoriteListResponse>(`${BASE_URL}/${userId}/favorite`, { params });

        return res.data.favorites;
    }

    public static async create(userId: string, favorite: FavoriteCreateForm): Promise<void> {
        await axios.post(`${BASE_URL}/${userId}/favorite`, favorite);
    }

    public static async update(userId: string, favoriteId: string, favorite: FavoriteUpdateForm): Promise<void> {
        await axios.put(`${BASE_URL}/${userId}/favorite/${favoriteId}`, favorite);
    }

    public static async remove(userId: string, favoriteId: string): Promise<void> {
        await axios.delete(`${BASE_URL}/${userId}/favorite/${favoriteId}`);
    }

    public static async updateOrder(params: FavoriteOrderUpdateParams[]): Promise<void> {
        await axios.put(`/api/favorite/order`, { favoriteOrder: params });
    }
}

export { BASE_URL as FAVORITE_BASE_URL };
